function ProductMedia({ product }) {
  const primaryVideo = Array.isArray(product?.videos) && product.videos.length > 0 ? product.videos[0] : null;
  const sourceType = String(product?.sourceType || primaryVideo?.sourceType || product?.videoType || '').toLowerCase();
  const videoUrl = product?.videoUrl || primaryVideo?.videoUrl || '';
  const embedUrl = product?.embedUrl || primaryVideo?.embedUrl || videoUrl;
  const thumbnailUrl = product?.thumbnailUrl || product?.thumbnail || primaryVideo?.thumbnailUrl || '';
  console.log(product.name + " " + embedUrl); 
  if (sourceType === 'youtube' || sourceType === 'youtubeshorts') {
    if (thumbnailUrl) {
      return (
        <img
          src={thumbnailUrl}
          alt={product?.name || 'Video'}
          loading="lazy"
          className="w-full h-full object-cover block"
        />
      );
    }

    return (
      <div className="h-full w-full grid place-items-center text-white/80 text-xs uppercase tracking-[0.12em] bg-gradient-to-br from-slate-700 to-slate-950">
        N/A
      </div>
    );
  }

  if (sourceType === 'tiktok') {
    if (embedUrl) {
      return (
        <div className="relative h-full w-full overflow-hidden bg-slate-950">
          <iframe
            src={embedUrl}
            title={product?.name || 'Video'}
            loading="eager"
            className="absolute inset-0 h-full w-full border-0 pointer-events-none"
            allowFullScreen
          />
        </div>
      );
    }
  }

  if (thumbnailUrl) {
    return (
      <img
        src={thumbnailUrl}
        alt={product?.name || 'Video'}
        loading="lazy"
        className="w-full h-full object-cover block"
      />
    );
  }

  if (embedUrl) {
    return (
      <div className="relative h-full w-full overflow-hidden bg-slate-950">
        <iframe
          src={embedUrl}
          title={product?.name || 'Video'}
          loading="eager"
          className="absolute inset-0 h-full w-full border-0 pointer-events-none"
          allowFullScreen
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between gap-2 p-2">
          <span className="rounded-full bg-black/60 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white">
            {sourceType || 'Video'}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full w-full grid place-items-center text-white/80 text-xs uppercase tracking-[0.12em] bg-gradient-to-br from-slate-700 to-slate-950">
      {sourceType === 'tiktok' ? 'TikTok' : 'Video'}
    </div>
  );
}

export default ProductMedia;
